import { AxiosError } from 'axios';
import { CustomError } from '../types/Error';

export const getErrorMessage = (
  e: AxiosError<CustomError> | AxiosError<Error> | Error | any,
  guid = '',
) => {
  let error: string;

  if (e?.response?.data?.errors?.[0]?.path && e?.response?.data?.errors?.[0]?.message) {
    error = `${e?.response?.data?.errors?.[0]?.path}: ${e?.response?.data?.errors?.[0]?.message}`;
  } else if (e?.response?.data?.errors?.length) {
    error = e.response.data.errors
      .map((error: any, index: number) => `${index + 1}. ${error?.message}`)
      ?.join('\n');
  } else if (guid && e?.[guid]?.errors?.length) {
    error = e[guid].errors
      .map((error: any, index: number) => `${index + 1}. ${error?.message}`)
      ?.join('\n');
  } else if (e?.response?.data?.errors?.[0]?.data?.message) {
    error = e.response.data.errors[0].data.message;
  } else if (e?.response?.data?.message) {
    error = e.response.data.message;
  } else if (e?.response?.data?.error && typeof e.response.data.error === 'string') {
    error = e.response.data.error;
  } else if (typeof e?.response?.data === 'string' && e.response.data.length) {
    error = e.response.data;
  } else {
    error = e.message;
  }

  return error;
};
